import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import Logo from "../asstes//images/Logo-1.png";


function Footer() {
  return (
    <Box mt="80px" bgcolor="#FFF3F4">
      <Stack
        gap="40px"
        sx={{ alignItems: "center" }}
        pt="24px"
        px="40px"
        flexWrap="wrap"
      >
        <img src={Logo} alt="logo" style={{ width: "200px", height: "41px" }} />
      </Stack>
      <Typography
        variant="h5"
        sx={{ fontSize: { lg: "28px", xs: "20px" } }}
        mt="41px"
        textAlign="center"
        pb="40px"
      >
        Made with ❤️ by KingKuntta
      </Typography>
    </Box>
  );
}

export default Footer
